import { memo } from "react";
import FallbackContainer from "./Container";

export const Error = memo(function Error({ error }: { error?: Error }) {
  return (
    <FallbackContainer>
      <div data-testid="error">Error</div>
      <div data-testid="error-text">{error?.message}</div>
    </FallbackContainer>
  );
});

export default Error;
